import PageActions from '@/lib/ui/models/PageActions';

const withPageActions = (superClass) => class extends superClass {
  pageActions = new PageActions();
};

export default withPageActions;
